import React from 'react'

const BlindsPattern = () => {
  return (
    <div
      className="absolute top-0 left-0 w-full h-full opacity-80"
      style={{
        background:
          'repeating-linear-gradient(0deg, transparent, transparent 8px, rgba(0,0,0,0.3) 8px, rgba(0,0,0,0.3) 12px)',
      }}
    />
  )
}

export default BlindsPattern
